import { render, staticRenderFns } from "./metricItemList.vue?vue&type=template&id=328f9a14&scoped=true&"
import script from "./metricItemList.vue?vue&type=script&lang=js&"
export * from "./metricItemList.vue?vue&type=script&lang=js&"
import style0 from "./metricItemList.vue?vue&type=style&index=0&id=328f9a14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328f9a14",
  null
  
)

export default component.exports